(function () {
  'use strict';

  angular.module('app').component('transportationList', transportationList());

  function transportationList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
        defaultLanguage: '<',
        userLanguageCode: '<',
      },
      controller: TransportationListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation/transportation-list/transportation-list.component.html',
    };
  }

  TransportationListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'TransportationService',

    // Angular downgraded service
    'locationService',
  ];

  function TransportationListComponent(
    config,
    UtilService,
    AbilityService,
    TransportationService,

    // Angular downgraded service
    locationService
  ) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_transportation_accountadmin'),
      canUpdate: AbilityService.can('update_transportation_accountadmin'),
      canDestroy: AbilityService.can('destroy_transportation_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = TransportationService.getFilterCriteria();

    vm.scheduleTypes = config.SCHEDULE_TYPES;

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.timeOptions = config.TIME_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.changeItemFeatured = changeItemFeatured;

    vm.searchLocations = (search, option) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      locationService.getLocations(params).subscribe((response) => {
        let locations = response;

        if (option === 'departure') {
          vm.departureLocations = locations;
        } else {
          vm.arrivalLocations = locations;
        }
      });
    };

    vm.clearLocations = (option) => {
      if (option === 'departure') {
        vm.departureLocations = [];
      } else {
        vm.arrivalLocations = [];
      }

      vm.UtilService.filterResult();
    };

    vm.popover = {
      templateUrl: 'options.html',
      open: function open(item) {
        vm.transportation = item;
        // vm.transportationSchedules = item.transportation_schedules;
      },
    };

    function fetchResult() {
      // vm.filterCriteria.lang = vm.defaultLanguage; // not needed

      vm.loadingItems = true;
      TransportationService.getTransportations(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.departureLocations = [];
      vm.arrivalLocations = [];

      vm.filterCriteria = TransportationService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowItem({ item: item, mode: mode });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      TransportationService.deleteTransportation(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      TransportationService.changeTransportationStatus(item);
    }

    function changeItemFeatured(item) {
      TransportationService.changeTransportationFeatured(item);
    }
  }
})();
